import createVueApp from '@phoenix/createVueApp';
import DesignDetailsHighlightModal from '@maison/components/organisms/DesignDetailsHighlightModal.vue';

document.querySelectorAll('.phoenix-design-details-highlight-modal').forEach((el) => {
  const app = createVueApp();
  app.component('DesignDetailsHighlightModal', DesignDetailsHighlightModal);
  app.mount(el);
});
